// packages block
import React from "react";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
// common block
import { preaddStyles } from "./styles";
import { TextFieldComponent } from "../form/textFeild";
// constants, theme, utils and api block

export const AddBankForm = ({
  bankName,
  bankSwiftCode,
  bankAddress,
  accountNumber,
  accountTitle,
  accountIban,
  bankSwiftCodeError,
  bankAddressError,
  accountNumberError,
  accountTitleError,
  accountIbanError,
  handleChange,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();

  const personal_Details = {
    fontWeight: 700,
    fontFamily: "Monsteric, sans-serif",
    fontSize: "1.1vw",
    color: "rgb(13, 110, 124)",
    marginBottom: "30px"
  };
  
  return (
    <div className={classes.addBankForm}>
      <h5 style={personal_Details}>
        {"Add New Bank"}
      </h5>
      <Grid container className={classes.gridRoot} spacing={2}>
        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            disabled={true}
            value={bankName}
            onChange={handleChange}
            label={t("text_bank_name")}
            name={"bankName"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage= {bankSwiftCodeError=== true && t("text_bank_swift_code")+ ' '+t("text_is_required")}
            error={bankSwiftCodeError}
            value={bankSwiftCode}
            onChange={handleChange}
            label={t("text_bank_swift_code")}
            name={"bankSwiftCode"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage= {bankAddressError=== true && t("text_bank_address")+ ' '+t("text_is_required")}
            error={bankAddressError}
            value={bankAddress}
            onChange={handleChange}
            label={t("text_bank_address")}
            name={"bankAddress"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage= {accountNumberError=== true && t("text_account_number")+ ' '+t("text_is_required")}
            error={accountNumberError}
            value={accountNumber}
            onChange={handleChange}
            label={t("text_account_number")}
            name={"accountNumber"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage= {accountTitleError=== true && t("text_account_title")+ ' '+t("text_is_required")}
            error={accountTitleError}
            value={accountTitle}
            onChange={handleChange}
            label={t("text_account_title")}
            name={"accountTitle"}
          />
        </Grid>

        <Grid item sm={6} xs={12}>
          <TextFieldComponent
            required={true}
            errorMessage= {accountIbanError=== true && t("text_account_iban")+ ' '+t("text_is_required")}
            error={accountIbanError}
            value={accountIban}
            onChange={handleChange}
            label={t("text_account_iban")}
            name={"accountIban"}
          />
        </Grid>
      </Grid>
    </div>
  );
};
